import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit-pen",
  "use": "icon-edit-pen-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edit-pen\">\n<path d=\"M4.27556 14.4588L8.44387 16.8651L13.2564 8.52913L9.08806 6.12288L4.27556 14.4588ZM3.75994 15.7479L4.46875 18.9276L7.58381 17.9389L3.75994 15.7479ZM9.77556 4.91975L13.9439 7.326L15.1683 5.22019L11 2.81394L9.77556 4.91975ZM2.23438 15.2323L10.4844 0.945312L17.0369 4.72656L8.78694 19.0135L3.45881 20.6896L2.23438 15.2323ZM10.4844 20.6896V19.3146H20.1094V20.6896H10.4844Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/edit-pen.svg
// module id = ZcPL
// module chunks = 262